import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskKbRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-kb',
	path: '/jira/servicedesk/projects/:projectKey/settings/confluence-kb',
	exact: true,
};
